import './CollageTeam1920.css';
import collage from '../../../img/company/CallageTeam.webp';


const CollageTeam1920 = () => {

    function shadowingAnimation(mouse, block) {
        const loop = document.querySelector('.companyCollage__img1920');
        let x = mouse.pageX;
        let y = mouse.pageY;
        let percW = block.offsetWidth / 100;
        let percH = block.offsetHeight / 100;
        let resW = x - block.offsetLeft;
        let resH = y - block.offsetTop;
        let resX = resW / percW;
        let resY = resH / percH;
        loop.style.transform = `translateY(-${resY}%) translateX(-${resX}%)`;
        loop.style.left = `${resX}%`;
        loop.style.top = `${resY}%`;
        loop.style.transition = 'none'
    }

    function shadowingDefault() {
        const loop = document.querySelector('.companyCollage__img1920');
        loop.style.transform = `translateY(-50%) translateX(-50%)`;
        loop.style.left = `50%`;
        loop.style.top = `50%`;
        loop.style.transition = 'ease 1s'
    }

    return (
        <div
            className='companyCollage1920'
            onMouseMove={e => shadowingAnimation(e, e.target.parentNode)}
            onMouseLeave={e => shadowingDefault()}
        >

            <img className='companyCollage__img1920' src={collage} alt="Nitrix family <3" />

        </div>
    );
};

export default CollageTeam1920;
